import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import { toast } from 'sonner';
import type { AuthProviderInfo } from 'pocketbase';

import { pb } from '@/lib/pocketbase';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function LoginPage() {
  const [, navigate] = useLocation();
  const [providers, setProviders] = useState<AuthProviderInfo[]>([]);
  const [pendingProvider, setPendingProvider] = useState<string | null>(null);

  useEffect(() => {
    pb.collection('users')
      .listAuthMethods()
      .then((methods) => setProviders(methods.oauth2.providers))
      .catch(() => toast.error("Impossible de récupérer les fournisseurs d'authentification."));
  }, []);

  const handleLogin = async (provider: AuthProviderInfo) => {
    setPendingProvider(provider.name);
    try {
      await pb.collection('users').authWithOAuth2({ provider: provider.name });
      navigate('/');
    } catch {
      toast.error('Connexion annulée ou échouée.');
    } finally {
      setPendingProvider(null);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm items-center py-9 text-center">
        <div className="flex size-11 items-center justify-center rounded-[13px] bg-primary text-lg font-bold text-primary-foreground">
          S
        </div>
        <CardHeader className="w-full items-center px-9">
          <CardTitle>Connexion</CardTitle>
          <CardDescription>Accédez à vos simulations SaaS Pricing Simulator.</CardDescription>
        </CardHeader>
        <CardContent className="flex w-full flex-col gap-2.5 px-9">
          {providers.length === 0 && (
            <p className="text-sm text-muted-foreground">
              Aucun fournisseur d’authentification n’est configuré.
            </p>
          )}
          {providers.map((provider, i) => (
            <Button
              key={provider.name}
              variant={i === 0 ? 'default' : 'outline'}
              className="w-full"
              disabled={pendingProvider !== null}
              onClick={() => handleLogin(provider)}
            >
              Continuer avec {provider.displayName}
            </Button>
          ))}
          <p className="mt-2 text-xs text-muted-foreground">
            Authentification OIDC uniquement — pas de mot de passe.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
